var _defs, _g, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_1-Email",
    "data-name": "1-Email",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f6b445;}.cls-2{fill:#fed049;}.cls-3{fill:none;stroke:#474c54;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Email") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47,9V37a4.025,4.025,0,0,1-1.17,2.83L28,22l-.28-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.83,39.83A4.025,4.025,0,0,1,43,41H5a4.025,4.025,0,0,1-2.83-1.17L20,22l.25-.39L24,24l3.72-2.43L28,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.25,21.61,20,22,2.17,39.83A4.025,4.025,0,0,1,1,37V11a3.944,3.944,0,0,1,.18-1.19L2,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47,9,27.72,21.57,24,24l-3.75-2.39L2,10l-.82-.19A4,4,0,0,1,5,7H42C46,7,47,9,47,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42,7H5A4,4,0,0,0,1.18,9.81,3.944,3.944,0,0,0,1,11V37a3.995,3.995,0,0,0,4,4H43a3.995,3.995,0,0,0,4-4V9L27.72,21.57,24,24l-3.75-2.39L2,10"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 39,
    y1: 33,
    x2: 28,
    y2: 22
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 9,
    y1: 33,
    x2: 20,
    y2: 22
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.15e0e21a5694bb942f5e3551e743f2bf.svg";
export { ForwardRef as ReactComponent };